export default {
  okta: {
    baseUrl: 'https://tempus.oktapreview.com',
    issuer: 'ausudtd99sCgoQEf30h7',
    clientId: '0oa1xh8sgr2Fy1nhR0h8',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedClientIds: {
    clinicalPortal: '0oag72ns7qfcE4gDr0h7',
    lensNotebook: '0oaqegazqdyP0Jhuy0h7',
    lensNotebook2: '0oamc9v0naJv40dpJ0h7',
    lensGlass: '0oaeqck2ljsd5rnfB0h7',
    accountUi: '0oa1xh8sgr2Fy1nhR0h8',
    therapiesSites: '0oay8pr3taSKYJ0wA0h7',
    therapiesSponsors: '0oay8x09lf9UOdeaZ0h7',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedIssuerIds: {
    default: 'ausudtd99sCgoQEf30h7',
    demo: 'ausljcfleg4KQAT5C0h7',
    stagingDemo: 'ausigvgms1mmEKe8Q0h7',
  },
  apps: {
    clinicalPortal: 'http://local.devtempus.com:3001',
    lens: 'https://lens.devtempus.com',
    therapiesSites: 'https://link-sites.devtempus.com',
    therapiesSponsors: 'https://link-sponsors.devtempus.com',
    providerAccount: 'http://localhost:4500',
    ehrIntegrationService: 'https://ehr-integration-service.devtempus.com',
  },
  sentry: {},
};
